// extracted by mini-css-extract-plugin
module.exports = {"content":"PlanFactExtraCostSubsections_content__1aTYz","row":"PlanFactExtraCostSubsections_row__1faX2"};